import { STATUS } from "../lib/api";

export default function StatusBadge({ status, className = "" }) {
  const s = STATUS[status] || { label: status, bg: "bg-zinc-100", text: "text-zinc-600", border: "border-zinc-300" };
  return (
    <span data-testid={`badge-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${s.bg} ${s.text} ${s.border} ${className}`}>
      {s.label}
    </span>
  );
}
